import { TicketCartItem } from '../components/sector-selection/sector-selection.model';

export function ticketEntriesPerUnit(item: TicketCartItem): number {
  return item.entriesPerUnit ?? (item.category === 'children-2x1' || item.category === 'senior-2x1' ? 2 : 1);
}

export function ticketUnitPriceCents(item: TicketCartItem): number {
  return Math.max(0, Math.round((item.sector.precio + item.tarifa.precio) * 100));
}

export function ticketLineTotalCents(item: TicketCartItem): number {
  return ticketUnitPriceCents(item) * item.cantidad;
}
